import { render, staticRenderFns } from "./DeactivatedAds.vue?vue&type=template&id=4109ec12&lang=html&"
import script from "./DeactivatedAds.vue?vue&type=script&lang=js&"
export * from "./DeactivatedAds.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports